import { render, staticRenderFns } from "./Codemirror.vue?vue&type=template&id=98087e9c"
import script from "./Codemirror.vue?vue&type=script&lang=js"
export * from "./Codemirror.vue?vue&type=script&lang=js"
import style0 from "./Codemirror.vue?vue&type=style&index=0&id=98087e9c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports